import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from 'app/application-http-client';
import { Observable } from 'rxjs';

@Injectable()
export class DealershipService {
  private readonly dealhershipControllerUrl = '/system/dealerships';

  // It retrieves a dealer name by it's give store key
  public getName(storeKey: number): Observable<string> {
    return this.http.get(`${this.dealhershipControllerUrl}/getname/${storeKey}`);
  }

  constructor(private http: ApplicationHttpClient) {}
}
